export const LOGIN_PATH = '/login'
